import { ElectronicSignatureDataSettingsModel } from '../../../shared/models';

export const defaultElectronicSignatureSettings: Omit<
  ElectronicSignatureDataSettingsModel,
  'documentTemplateKey'
> = {
  automaticApproval: true,
};
